import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NbButtonModule, NbCardModule, NbCheckboxModule, NbDialogRef, NbDialogService, NbInputModule } from '@nebular/theme';
import { UsuarioAtualizacao, UsuarioCriacao, UsuarioResposta } from '../../../core/api/usuario';
import { UsuarioAppService } from '../../../core/api/usuario-app.service';
import { DialogAlertComponent } from '../../inscricao/inscricao.dialog.component';

import { mensagemDeErro } from '../../../utils/mensagem-erro';
@Component({
  selector: 'app-usuario-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NbCardModule, NbButtonModule, NbInputModule, NbCheckboxModule],
  templateUrl: './usuario-form.component.html',
  styleUrl: './usuario-form.component.scss',
})
export class UsuarioFormComponent implements OnInit {
  @Input() usuario: UsuarioResposta | null = null;

  model: UsuarioResposta = this.novoVazio();

  constructor(
    private usuarioService: UsuarioAppService,
    protected ref: NbDialogRef<UsuarioFormComponent>,
    private dialog: NbDialogService,
  ) {}

  ngOnInit(): void {
    if (this.usuario) {
      this.model = {
        ...this.usuario,
        admin: !!this.usuario.admin,
        coordenacao: !!this.usuario.coordenacao,
        catequista: !!this.usuario.catequista,
      };
    }
  }

  /**
   * `PUT` é substituição (ver `UsuarioAtualizacao`): telefone e e-mail ausentes apagam o
   * gravado, e os três perfis ausentes revogam o acesso. Por isso o corpo é montado campo a
   * campo e completo — e os booleanos são coagidos, para "não marcado" virar `false`
   * explícito em vez de `undefined`.
   *
   * `criadoEm`/`atualizadoEm` ficam de fora: são da resposta, não da requisição.
   */
  private corpoCompleto(): UsuarioCriacao {
    return {
      login: (this.model.login ?? '').trim(),
      nome: (this.model.nome ?? '').trim(),
      cpf: (this.model.cpf ?? '').trim(),
      telefone: this.model.telefone ?? '',
      email: this.model.email ?? '',
      admin: !!this.model.admin,
      coordenacao: !!this.model.coordenacao,
      catequista: !!this.model.catequista,
    };
  }

  private novoVazio(): UsuarioResposta {
    return {
      login: '',
      nome: '',
      cpf: '',
      telefone: '',
      email: '',
      admin: false,
      coordenacao: false,
      catequista: false,
    };
  }

  salvar(): void {
    if (!this.model.login?.trim() || !this.model.nome?.trim() || !this.model.cpf?.trim()) {
      this.dialog.open(DialogAlertComponent, {
        context: { title: 'Validação', message: 'Preencha login, nome e CPF.' },
      });
      return;
    }
    const corpo = this.corpoCompleto();
    const obs = this.model.id
      ? this.usuarioService.atualizar(this.model.id, { ...corpo, id: this.model.id } as UsuarioAtualizacao)
      : this.usuarioService.criar(corpo);
    obs.subscribe({
      next: () => {
        this.ref.close(true);
        this.dialog.open(DialogAlertComponent, {
          context: { title: 'Sucesso', message: 'Usuário salvo com sucesso.' },
        });
      },
      error: (err) => {
        const msg = mensagemDeErro(err, 'Não foi possível salvar.');
        this.dialog.open(DialogAlertComponent, { context: { title: 'Erro', message: msg } });
      },
    });
  }

  fechar(): void {
    this.ref.close(false);
  }
}
